import CollapseItem from "../utils/collapse-item/CollapseItem";
import { cn } from "../../lib/utils";

const CollapsiblePlanContents = ({ chapters }) => {
	return chapters.map((chapter, i) => (
		<CollapseItem key={i}>
			<CollapseItem.Toggle>
				{({ isOpen }) => (
					<ListItem isInteractive={true} isOpen={isOpen} icon="folder">
						{chapter.name}
					</ListItem>
				)}
			</CollapseItem.Toggle>

			<CollapseItem.Content>
				{/* List Contents */}
				<div>
					{chapter.contents
						.filter((content) => content.content_type !== "organization_course")
						.map((content, i) =>
							content.content_type === "chapter_content" ? (
								<ListItem key={i} icon="text_box" className="pl-[72px]">
									{content?.name}
								</ListItem>
							) : (
								<CollapseItem key={i}>
									<CollapseItem.Toggle>
										{({ isOpen }) => (
											<ListItem
												isInteractive={true}
												isOpen={isOpen}
												icon="layers"
												className="pl-[72px]"
											>
												{content.name}
											</ListItem>
										)}
									</CollapseItem.Toggle>

									{/*List Requirements*/}
									<CollapseItem.Content>
										<div className="pl-[72px]">
											{content?.requirements?.map((req, i) => (
												<ListItem key={i} icon="layer">
													{req.name}
												</ListItem>
											))}
										</div>
									</CollapseItem.Content>
								</CollapseItem>
							)
						)}
				</div>
			</CollapseItem.Content>
		</CollapseItem>
	));
};

const ListItem = ({ isOpen, children, icon, isInteractive, className }) => {
	return (
		<div
			className={cn(
				"flex gap-3 py-3 pl-7 pr-9",
				isInteractive && "cursor-pointer hover:bg-primary-5 select-none",
				className
			)}
		>
			{isInteractive && (
				<div className="flex mt-1">
					<span
						className={cn("icon_16 default chevron icon_mask !bg-dark-50", !isOpen && "right")}
					/>
				</div>
			)}
			{icon && (
				<div className="flex mt-1">
					<span className={cn("icon_16 default", icon)} />
				</div>
			)}
			<div className="line-clamp-1">{children}</div>
		</div>
	);
};

export default CollapsiblePlanContents;
